import { IntegrationInterface } from '../types'

export const hasMultipleUseCases = (integration: IntegrationInterface) => {
  return integration.useCases.length > 1
}
